import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_6,
} from './operators';

import atendeTotal from './atendeTotal/constants';

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'private_note',
        name: 'PRIVATE_NOTE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'MESSAGE_CONTAINS',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'remove_assigned_agent',
        name: 'REMOVE_ASSIGNED_AGENT',
      },
      {
        key: 'remove_assigned_team',
        name: 'REMOVE_ASSIGNED_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'remove_assigned_agent',
        name: 'REMOVE_ASSIGNED_AGENT',
      },
      {
        key: 'remove_assigned_team',
        name: 'REMOVE_ASSIGNED_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'remove_assigned_agent',
        name: 'REMOVE_ASSIGNED_AGENT',
      },
      {
        key: 'remove_assigned_team',
        name: 'REMOVE_ASSIGNED_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'remove_assigned_agent',
        name: 'REMOVE_ASSIGNED_AGENT',
      },
      {
        key: 'remove_assigned_team',
        name: 'REMOVE_ASSIGNED_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  conversation_resolved: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'remove_assigned_agent',
        name: 'REMOVE_ASSIGNED_AGENT',
      },
      {
        key: 'remove_assigned_team',
        name: 'REMOVE_ASSIGNED_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  conversation_pending: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  conversation_snoozed: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  contact_updated: {
    conditions: [
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  team_changed: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  contact_created: {
    conditions: [
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
    ],
  },
  new_ad_portal_lead: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_deal_in_vista_if_customer_exists',
        name: 'CREATE_DEAL_IN_VISTA_IF_CUSTOMER_EXISTS',
      },
      {
        key: 'assign_conversation_to_vista_user',
        name: 'ASSIGN_CONVERSATION_TO_VISTA_USER',
      },
      {
        key: 'vista_sync_conversation_user',
        name: 'VISTA_SYNC_CONVERSATION_USER',
      },
      {
        key: 'vista_sync_contact_history',
        name: 'SYNC_CONTACT_HISTORY_TO_VISTA',
      },
      {
        key: 'atende_total_lead_distribution_if_not_assigned',
        name: 'ATENDE_TOTAL_LEAD_DISTRIBUTION_IF_NOT_ASSIGNED',
      },
      {
        key: 'create_or_update_lead_in_betabit',
        name: 'CREATE_OR_UPDATE_LEAD_IN_BETABIT',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      {
        key: 'create_lead_in_sigav360',
        name: 'CREATE_LEAD_IN_SIGAV360',
      },
      {
        key: 'create_lead_in_imoview_if_inexistent',
        name: 'CREATE_LEAD_IN_IMOVIEW_IF_INEXISTENT',
      },
      {
        key: 'create_lead_and_ticket_in_imoview',
        name: 'CREATE_LEAD_AND_TICKET_IN_IMOVIEW',
      },
      {
        key: 'assign_conversation_to_imoview_user',
        name: 'ASSIGN_CONVERSATION_TO_IMOVIEW_USER',
      },
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      {
        key: 'create_or_update_lead_in_properfy',
        name: 'CREATE_OR_UPDATE_LEAD_IN_PROPERFY',
      },
      {
        key: 'create_deal_in_properfy',
        name: 'CREATE_DEAL_IN_PROPERFY',
      },
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
    ],
  },
  new_lais_lead: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_deal_in_vista_if_customer_exists',
        name: 'CREATE_DEAL_IN_VISTA_IF_CUSTOMER_EXISTS',
      },
      {
        key: 'assign_conversation_to_vista_user',
        name: 'ASSIGN_CONVERSATION_TO_VISTA_USER',
      },
      {
        key: 'vista_sync_conversation_user',
        name: 'VISTA_SYNC_CONVERSATION_USER',
      },
      {
        key: 'vista_sync_contact_history',
        name: 'SYNC_CONTACT_HISTORY_TO_VISTA',
      },
      {
        key: 'atende_total_lead_distribution_if_not_assigned',
        name: 'ATENDE_TOTAL_LEAD_DISTRIBUTION_IF_NOT_ASSIGNED',
      },
      {
        key: 'create_or_update_lead_in_betabit',
        name: 'CREATE_OR_UPDATE_LEAD_IN_BETABIT',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      {
        key: 'create_lead_in_sigav360',
        name: 'CREATE_LEAD_IN_SIGAV360',
      },
      {
        key: 'create_lead_in_imoview_if_inexistent',
        name: 'CREATE_LEAD_IN_IMOVIEW_IF_INEXISTENT',
      },
      {
        key: 'create_lead_and_ticket_in_imoview',
        name: 'CREATE_LEAD_AND_TICKET_IN_IMOVIEW',
      },
      {
        key: 'assign_conversation_to_imoview_user',
        name: 'ASSIGN_CONVERSATION_TO_IMOVIEW_USER',
      },
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      {
        key: 'create_or_update_lead_in_properfy',
        name: 'CREATE_OR_UPDATE_LEAD_IN_PROPERFY',
      },
      {
        key: 'create_deal_in_properfy',
        name: 'CREATE_DEAL_IN_PROPERFY',
      },
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
    ],
  },
  new_integrator_lead: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_deal_in_vista_if_customer_exists',
        name: 'CREATE_DEAL_IN_VISTA_IF_CUSTOMER_EXISTS',
      },
      {
        key: 'assign_conversation_to_vista_user',
        name: 'ASSIGN_CONVERSATION_TO_VISTA_USER',
      },
      {
        key: 'vista_sync_conversation_user',
        name: 'VISTA_SYNC_CONVERSATION_USER',
      },
      {
        key: 'vista_sync_contact_history',
        name: 'SYNC_CONTACT_HISTORY_TO_VISTA',
      },
      {
        key: 'atende_total_lead_distribution_if_not_assigned',
        name: 'ATENDE_TOTAL_LEAD_DISTRIBUTION_IF_NOT_ASSIGNED',
      },
      {
        key: 'create_or_update_lead_in_betabit',
        name: 'CREATE_OR_UPDATE_LEAD_IN_BETABIT',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      {
        key: 'create_lead_in_sigav360',
        name: 'CREATE_LEAD_IN_SIGAV360',
      },
      {
        key: 'create_lead_in_imoview_if_inexistent',
        name: 'CREATE_LEAD_IN_IMOVIEW_IF_INEXISTENT',
      },
      {
        key: 'create_lead_and_ticket_in_imoview',
        name: 'CREATE_LEAD_AND_TICKET_IN_IMOVIEW',
      },
      {
        key: 'assign_conversation_to_imoview_user',
        name: 'ASSIGN_CONVERSATION_TO_IMOVIEW_USER',
      },
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      {
        key: 'create_or_update_lead_in_properfy',
        name: 'CREATE_OR_UPDATE_LEAD_IN_PROPERFY',
      },
      {
        key: 'create_deal_in_properfy',
        name: 'CREATE_DEAL_IN_PROPERFY',
      },
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
    ],
  },
  conversation_open_by_inactivity: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_deal_in_vista_if_customer_exists',
        name: 'CREATE_DEAL_IN_VISTA_IF_CUSTOMER_EXISTS',
      },
      {
        key: 'assign_conversation_to_vista_user',
        name: 'ASSIGN_CONVERSATION_TO_VISTA_USER',
      },
      {
        key: 'vista_sync_conversation_user',
        name: 'VISTA_SYNC_CONVERSATION_USER',
      },
      {
        key: 'atende_total_lead_distribution_if_not_assigned',
        name: 'ATENDE_TOTAL_LEAD_DISTRIBUTION_IF_NOT_ASSIGNED',
      },
      {
        key: 'create_or_update_lead_in_betabit',
        name: 'CREATE_OR_UPDATE_LEAD_IN_BETABIT',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      {
        key: 'create_lead_in_sigav360',
        name: 'CREATE_LEAD_IN_SIGAV360',
      },
      {
        key: 'create_lead_in_imoview_if_inexistent',
        name: 'CREATE_LEAD_IN_IMOVIEW_IF_INEXISTENT',
      },
      {
        key: 'create_lead_and_ticket_in_imoview',
        name: 'CREATE_LEAD_AND_TICKET_IN_IMOVIEW',
      },
      {
        key: 'assign_conversation_to_imoview_user',
        name: 'ASSIGN_CONVERSATION_TO_IMOVIEW_USER',
      },
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      {
        key: 'create_or_update_lead_in_properfy',
        name: 'CREATE_OR_UPDATE_LEAD_IN_PROPERFY',
      },
      {
        key: 'create_deal_in_properfy',
        name: 'CREATE_DEAL_IN_PROPERFY',
      },
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
    ],
  },
  conversation_resolved_by_inactivity: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_within_business_hours',
        name: 'BUSINESS_HOURS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_deal_in_vista_if_customer_exists',
        name: 'CREATE_DEAL_IN_VISTA_IF_CUSTOMER_EXISTS',
      },
      {
        key: 'assign_conversation_to_vista_user',
        name: 'ASSIGN_CONVERSATION_TO_VISTA_USER',
      },
      {
        key: 'vista_sync_conversation_user',
        name: 'VISTA_SYNC_CONVERSATION_USER',
      },
      {
        key: 'atende_total_lead_distribution_if_not_assigned',
        name: 'ATENDE_TOTAL_LEAD_DISTRIBUTION_IF_NOT_ASSIGNED',
      },
      {
        key: 'create_or_update_lead_in_betabit',
        name: 'CREATE_OR_UPDATE_LEAD_IN_BETABIT',
      },
      atendeTotal.c2s.createLeadInC2s.automationAction,
      atendeTotal.flexpro.createInterestInFlexpro.automationAction,
      {
        key: 'create_lead_in_sigav360',
        name: 'CREATE_LEAD_IN_SIGAV360',
      },
      {
        key: 'create_lead_in_imoview_if_inexistent',
        name: 'CREATE_LEAD_IN_IMOVIEW_IF_INEXISTENT',
      },
      {
        key: 'create_lead_and_ticket_in_imoview',
        name: 'CREATE_LEAD_AND_TICKET_IN_IMOVIEW',
      },
      {
        key: 'assign_conversation_to_imoview_user',
        name: 'ASSIGN_CONVERSATION_TO_IMOVIEW_USER',
      },
      atendeTotal.msys_imob.createLeadInMsysImob.automationAction,
      atendeTotal.piperun.createOrUpdatePersonInPiperun.automationAction,
      atendeTotal.piperun.createOpportunityInPiperun.automationAction,
      atendeTotal.promentor.createCustomerAndTicketInPromentor.automationAction,
      atendeTotal.promentor.assignConversationToPromentorPropertyUser
        .automationAction,
      {
        key: 'create_or_update_lead_in_properfy',
        name: 'CREATE_OR_UPDATE_LEAD_IN_PROPERFY',
      },
      {
        key: 'create_deal_in_properfy',
        name: 'CREATE_DEAL_IN_PROPERFY',
      },
      atendeTotal.via_imob.createLeadInViaImob.automationAction,
      atendeTotal.nido_imovel.createLeadInNidoImovel.automationAction,
      atendeTotal.createDeal.automationAction,
      atendeTotal.pipefy.attachLabelToDealInPipefy.automationAction,
      {
        key: 'portal_lead_distribution',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
    ],
  },
};

// A chamado was opened. Conditions are evaluated against the card's primary conversation,
// so it reuses the conversation vocabulary unchanged.
AUTOMATIONS.card_created = {
  conditions: structuredClone(AUTOMATIONS.conversation_created.conditions),
  actions: structuredClone(AUTOMATIONS.conversation_created.actions),
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'CONVERSATION_CREATED',
  },
  {
    key: 'conversation_updated',
    value: 'CONVERSATION_UPDATED',
  },
  {
    key: 'conversation_resolved',
    value: 'CONVERSATION_RESOLVED',
  },
  {
    key: 'message_created',
    value: 'MESSAGE_CREATED',
  },
  {
    key: 'conversation_opened',
    value: 'CONVERSATION_OPENED',
  },
  {
    key: 'conversation_pending',
    value: 'CONVERSATION_PENDING',
  },
  {
    key: 'conversation_snoozed',
    value: 'CONVERSATION_SNOOZED',
  },
  {
    key: 'contact_updated',
    value: 'CONTACT_UPDATED',
  },
  {
    key: 'team_changed',
    value: 'TEAM_CHANGED',
  },
  {
    key: 'contact_created',
    value: 'CONTACT_CREATED',
  },
  {
    key: 'card_created',
    value: 'CARD_CREATED',
  },
  {
    key: 'new_ad_portal_lead',
    value: 'NEW_AD_PORTAL_LEAD',
  },
  {
    key: 'new_lais_lead',
    value: 'NEW_LAIS_LEAD',
  },
  {
    key: 'new_integrator_lead',
    value: 'NEW_INTEGRATOR_LEAD',
  },
  {
    key: 'conversation_open_by_inactivity',
    value: 'CONVERSATION_OPEN_BY_INACTIVITY',
  },
  {
    key: 'conversation_resolved_by_inactivity',
    value: 'CONVERSATION_RESOLVED_BY_INACTIVITY',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'if_else',
    label: 'IF_ELSE',
    inputType: null,
  },
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'remove_assigned_agent',
    label: 'REMOVE_ASSIGNED_AGENT',
    inputType: null,
  },
  {
    key: 'remove_assigned_team',
    label: 'REMOVE_ASSIGNED_TEAM',
    inputType: null,
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'pending_conversation',
    label: 'PENDING_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'send_whatsapp_template_message',
    label: 'SEND_WHATSAPP_TEMPLATE_MESSAGE',
    inputType: null,
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'ADD_SLA',
    inputType: 'search_select',
  },
  {
    key: 'update_custom_attribute',
    label: 'UPDATE_CUSTOM_ATTRIBUTE',
    inputType: 'textarea',
  },
  {
    key: 'atende_total_lead_distribution_if_not_assigned',
    label: 'ATENDE_TOTAL_LEAD_DISTRIBUTION_IF_NOT_ASSIGNED',
    inputType: null,
  },
  {
    key: 'portal_lead_distribution',
    label: 'PORTAL_LEAD_DISTRIBUTION',
    inputType: null,
  },
  {
    key: 'create_lead_in_arbo',
    label: 'CREATE_LEAD_IN_ARBO',
    inputType: 'text',
  },
  {
    key: 'create_or_update_lead_in_betabit',
    label: 'CREATE_OR_UPDATE_LEAD_IN_BETABIT',
    inputType: null,
  },
  {
    key: 'create_lead_in_casasoft',
    label: 'CREATE_LEAD_IN_CASASOFT',
    inputType: null,
  },
  atendeTotal.c2s.createLeadInC2s.automationActionType,
  atendeTotal.flexpro.createInterestInFlexpro.automationActionType,
  {
    key: 'create_lead_in_sigav360',
    label: 'CREATE_LEAD_IN_SIGAV360',
    inputType: null,
  },
  {
    key: 'create_lead_in_imoview_if_inexistent',
    label: 'CREATE_LEAD_IN_IMOVIEW_IF_INEXISTENT',
    inputType: null,
  },
  {
    key: 'create_lead_and_ticket_in_imoview',
    label: 'CREATE_LEAD_AND_TICKET_IN_IMOVIEW',
    inputType: null,
  },
  {
    key: 'assign_conversation_to_imoview_user',
    label: 'ASSIGN_CONVERSATION_TO_IMOVIEW_USER',
    inputType: null,
  },
  atendeTotal.msys_imob.createLeadInMsysImob.automationActionType,
  atendeTotal.piperun.createOrUpdatePersonInPiperun.automationActionType,
  atendeTotal.piperun.createOpportunityInPiperun.automationActionType,
  atendeTotal.promentor.createCustomerAndTicketInPromentor.automationActionType,
  atendeTotal.promentor.assignConversationToPromentorPropertyUser
    .automationActionType,
  {
    key: 'create_or_update_lead_in_properfy',
    label: 'CREATE_OR_UPDATE_LEAD_IN_PROPERFY',
    inputType: null,
  },
  {
    key: 'create_deal_in_properfy',
    label: 'CREATE_DEAL_IN_PROPERFY',
    inputType: 'textarea',
  },
  atendeTotal.via_imob.createLeadInViaImob.automationActionType,
  atendeTotal.nido_imovel.createLeadInNidoImovel.automationActionType,
  atendeTotal.createDeal.automationActionType,
  atendeTotal.pipefy.attachLabelToDealInPipefy.automationActionType,
  {
    key: 'create_contact_in_vista_if_not_exist',
    label: 'CREATE_CONTACT_IN_VISTA_IF_NOT_EXIST',
    inputType: null,
  },
  {
    key: 'vista_create_lead',
    label: 'VISTA_CREATE_LEAD',
    inputType: null,
  },
  {
    key: 'create_deal_in_vista_if_customer_exists',
    label: 'CREATE_DEAL_IN_VISTA_IF_CUSTOMER_EXISTS',
    inputType: 'textarea',
  },
  {
    key: 'assign_conversation_to_vista_user',
    label: 'ASSIGN_CONVERSATION_TO_VISTA_USER',
    inputType: null,
  },
  {
    key: 'vista_sync_conversation_user',
    label: 'VISTA_SYNC_CONVERSATION_USER',
    inputType: null,
  },
  {
    key: 'vista_sync_contact_history',
    label: 'VISTA_SYNC_CONTACT_HISTORY',
    inputType: null,
  },
  {
    key: 'vista_assign_atende_total_agent_to_customer',
    label: 'VISTA_ASSIGN_ATENDE_TOTAL_AGENT_TO_CUSTOMER',
    inputType: null,
  },
  {
    key: 'vista_assign_property_agent_to_conversation',
    label: 'VISTA_ASSIGN_PROPERTY_AGENT_TO_CONVERSATION',
    inputType: null,
  },
];
